import * as uuid from "uuid";
import mongoose from "mongoose";

export interface ShoppingCartItem {
  _id: mongoose.Schema.Types.ObjectId;
  solutionId: string | number;
  bundleId: string | number;
  localizationCode: string;
  quantity: number;
}

export interface ShoppingCartHomeAddress {
  homeBuilding: string;
  homeCity: string;
  homeState: string;
  homeZip: string;
  homeCountry: string;
}

export interface ShoppingCart {
  _id: mongoose.Schema.Types.ObjectId;
  cartId: string;
  customerId: string;
  userId: string;
  contractId?: string;
  /** ISO Country Code */
  country?: string;
  // eslint-disable-next-line
  site?: any;
  // eslint-disable-next-line
  shippingInfo?: any;
  purchaseOrderFileName?: string;
  bigDealNumber?: string;
  hpfsNumber?: string;
  items: ShoppingCartItem[];
  homeAddress?: ShoppingCartHomeAddress;
}

export const ShoppingCartSchema = new mongoose.Schema<ShoppingCart>({
  cartId: { type: String, default: () => uuid.v1().replace(/[^0-9abcdef]/g, "") }, // becomes Order ID
  customerId: String,
  userId: String,
  contractId: String,
  country: String, // ISO country code
  site: mongoose.Schema.Types.Mixed,
  shippingInfo: {},
  purchaseOrderFileName: String,
  bigDealNumber: String,
  hpfsNumber: String,
  items: [{
    solutionId: mongoose.Schema.Types.Mixed,
    bundleId: mongoose.Schema.Types.Mixed,
    localizationCode: String,
    quantity: mongoose.Schema.Types.Number,
  }],
  homeAddress: {
    homeBuilding: String,
    homeCity: String,
    homeState: String,
    homeZip: String,
    homeCountry: String,
  },
});

ShoppingCartSchema.index(
  { customerId: 1, userId: 1 },
  { unique: true },
);
